/**
 * ero-account-addresses.js  — Faz 1b-2
 * Hesabım sayfası adres yönetimi: listele + ekle/düzenle/sil/varsayılan.
 * App Proxy (/apps/hesap/account/addresses) → Admin API.
 *
 * Türk adres formatı: provinceCode Türkiye'de tutarsız olduğundan
 * il/ilçe `city = "İlçe / İl"` olarak birleştirilir (mevcut veriyle uyumlu).
 */
(function () {
  'use strict';
  var MOUNT = document.getElementById('ero-acct-addresses');
  var MODAL = document.getElementById('ero-addr-modal');
  if (!MOUNT || !MODAL) return;

  // Modal portal: section/ata öğede transform|filter|will-change varsa
  // position:fixed viewport yerine o ataya bağlanır → modal akışa düşüp footer'a karışır.
  // Modal'ı doğrudan <body>'ye taşıyarak viewport'a sabitlenmeyi garantiye alıyoruz.
  if (MODAL.parentElement !== document.body) {
    document.body.appendChild(MODAL);
  }

  var PROXY       = '/apps/hesap/account/addresses';
  var ACCOUNT_URL = MOUNT.getAttribute('data-account-url') || '/account';

  var state = { addresses: [], defaultId: null, editingId: null, busy: false };

  // Genel Bakış + Profil "Varsayılan Adres" ayna elemanları (yoksa sessizce atlanır)
  var OV_SECTION = document.getElementById('ero-ov-default-addr');
  var OV_CARD    = OV_SECTION && OV_SECTION.querySelector('[data-ov-addr-card]');
  var PROF_ROW   = document.getElementById('ero-prof-default-addr');
  var PROF_VALUE = PROF_ROW && PROF_ROW.querySelector('[data-prof-addr-value]');

  /* ── yardımcılar ── */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }
  function byId(id) {
    for (var i = 0; i < state.addresses.length; i++) if (state.addresses[i].id === id) return state.addresses[i];
    return null;
  }
  function buildCity(ilce, il) {
    ilce = (ilce || '').trim(); il = (il || '').trim();
    if (ilce && il) return ilce + ' / ' + il;
    return ilce || il || '';
  }
  function parseCity(city) {
    city = (city || '').trim();
    var i = city.indexOf(' / ');
    if (i === -1) return { ilce: city, il: '' };
    return { ilce: city.slice(0, i).trim(), il: city.slice(i + 3).trim() };
  }

  /* ── liste render ── */
  function addressLines(a) {
    if (a.formatted && a.formatted.length) return a.formatted.slice();
    var parts = [];
    var name = ((a.firstName || '') + ' ' + (a.lastName || '')).trim();
    if (name) parts.push(name);
    if (a.address1) parts.push(a.address1 + (a.address2 ? ', ' + a.address2 : ''));
    if (a.city) parts.push(a.city + (a.zip ? ', ' + a.zip : ''));
    if (a.phone) parts.push(a.phone);
    return parts;
  }
  function cardHTML(a, isDefault) {
    var lines = addressLines(a).map(esc).join('<br>');
    var actions =
      '<button type="button" class="ero-acct__address-link" data-act="edit" data-id="' + esc(a.id) + '">Düzenle</button>' +
      (isDefault ? '' : '<button type="button" class="ero-acct__address-link" data-act="setDefault" data-id="' + esc(a.id) + '">Varsayılan Yap</button>') +
      '<button type="button" class="ero-acct__address-link ero-acct__address-link--danger" data-act="delete" data-id="' + esc(a.id) + '">Sil</button>';
    return '<div class="ero-acct__address-card' + (isDefault ? ' is-default' : '') + '">' +
      (isDefault ? '<div class="ero-acct__address-default-badge">Varsayılan</div>' : '') +
      '<div class="ero-acct__address-lines">' + lines + '</div>' +
      '<div class="ero-acct__address-actions">' + actions + '</div></div>';
  }
  function addBtnHTML() {
    return '<div class="ero-acct__add-address-wrap">' +
      '<button type="button" class="ero-acct__add-address-btn" data-act="add">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
      'Yeni Adres Ekle</button></div>';
  }
  function emptyHTML() {
    return '<div class="ero-acct__empty">' +
      '<svg class="ero-acct__empty-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>' +
      '<div class="ero-acct__empty-title">Kayıtlı adres yok</div>' +
      '<div class="ero-acct__empty-sub">Daha hızlı ödeme için adresinizi ekleyin.</div>' +
      '<button type="button" class="ero-acct__empty-cta" data-act="add">Adres Ekle</button></div>';
  }
  /* Genel Bakış kartı + Profil satırı: tek doğru kaynak state (App Proxy fetch).
     Liquid customer.default_address statik + NCA'da güvenilmez olduğundan JS ile basılır. */
  function renderDefaultMirrors() {
    var def = state.defaultId ? byId(state.defaultId) : null;

    if (OV_SECTION && OV_CARD) {
      if (def) {
        OV_CARD.innerHTML =
          '<div class="ero-acct__address-default-badge">Varsayılan</div>' +
          '<div class="ero-acct__address-lines">' + addressLines(def).map(esc).join('<br>') + '</div>';
        OV_SECTION.hidden = false;
      } else {
        OV_SECTION.hidden = true;
      }
    }

    if (PROF_ROW && PROF_VALUE) {
      if (def) {
        var line = def.address1 || '';
        if (def.city) line += (line ? ', ' : '') + def.city;
        PROF_VALUE.textContent = line;
        PROF_ROW.hidden = false;
      } else {
        PROF_ROW.hidden = true;
      }
    }
  }

  function renderList() {
    renderDefaultMirrors();   // Genel Bakış + Profil aynalarını her durumda senkronla
    var addrs = state.addresses;
    if (!addrs.length) { MOUNT.setAttribute('data-state', 'empty'); MOUNT.innerHTML = emptyHTML(); return; }
    var def = state.defaultId;
    addrs = addrs.slice().sort(function (a, b) { return (b.id === def ? 1 : 0) - (a.id === def ? 1 : 0); });
    MOUNT.setAttribute('data-state', 'ready');
    MOUNT.innerHTML = addrs.map(function (a) { return cardHTML(a, a.id === def); }).join('') + addBtnHTML();
  }
  function fallback() {
    MOUNT.setAttribute('data-state', 'error');
    MOUNT.innerHTML = '<div class="ero-acct__empty"><div class="ero-acct__empty-sub">Adresler şu an yüklenemedi.</div>' +
      '<a href="' + esc(ACCOUNT_URL) + '" class="ero-acct__empty-cta">Hesabımda Görüntüle</a></div>';
  }

  /* ── modal ── */
  var F = {
    firstName: MODAL.querySelector('[name="firstName"]'),
    lastName:  MODAL.querySelector('[name="lastName"]'),
    phone:     MODAL.querySelector('[name="phone"]'),
    address1:  MODAL.querySelector('[name="address1"]'),
    il:        MODAL.querySelector('[name="il"]'),
    ilce:      MODAL.querySelector('[name="ilce"]'),
    zip:       MODAL.querySelector('[name="zip"]'),
    setDefault:MODAL.querySelector('[name="setAsDefault"]')
  };
  var TITLE = MODAL.querySelector('[data-modal-title]');
  var ERR   = MODAL.querySelector('[data-modal-error]');
  var SAVE  = MODAL.querySelector('[data-act="save"]');

  function fillForm(a) {
    var c = a ? parseCity(a.city) : { ilce: '', il: '' };
    F.firstName.value = a ? (a.firstName || '') : '';
    F.lastName.value  = a ? (a.lastName || '')  : '';
    F.phone.value     = a ? (a.phone || '')     : '';
    F.address1.value  = a ? (a.address1 || '')  : '';
    F.il.value        = c.il;
    F.ilce.value      = c.ilce;
    F.zip.value       = a ? (a.zip || '')       : '';
    F.setDefault.checked = a ? (a.id === state.defaultId) : false;
    F.setDefault.disabled = a ? (a.id === state.defaultId) : false;
  }
  function readForm() {
    return {
      firstName: F.firstName.value, lastName: F.lastName.value, phone: F.phone.value,
      address1: F.address1.value, il: F.il.value, ilce: F.ilce.value, zip: F.zip.value,
      setAsDefault: F.setDefault.checked
    };
  }
  function validate(f) {
    return ['firstName','lastName','phone','address1','il','ilce','zip'].filter(function (k) { return !(f[k] || '').trim(); });
  }
  function showError(msg) { ERR.textContent = msg; ERR.hidden = false; }
  function clearError() { ERR.textContent = ''; ERR.hidden = true; }

  function openModal(a) {
    state.editingId = a ? a.id : null;
    TITLE.textContent = a ? 'Adresi Düzenle' : 'Yeni Adres';
    clearError();
    fillForm(a);
    MODAL.removeAttribute('hidden');
    // Arka plan scroll kilidi: html + body birlikte (bazı cihazlarda scroll html'de)
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    setTimeout(function () { F.firstName.focus(); }, 50);
  }
  function closeModal() {
    MODAL.setAttribute('hidden', '');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    state.editingId = null;
  }

  /* ── ağ ── */
  function setBusy(b) {
    state.busy = b;
    if (SAVE) { SAVE.disabled = b; SAVE.textContent = b ? 'Kaydediliyor…' : 'Kaydet'; }
  }
  function post(payload) {
    return fetch(PROXY, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json().then(function (d) { return { status: r.status, d: d }; }); });
  }
  /* Hata mesajını response'tan türet — tek kaynak (DRY) */
  function resultErrorMsg(res) {
    var d = res.d;
    if (d && d.error === 'validation' && d.userErrors && d.userErrors.length) {
      return d.userErrors.map(function (e) { return e.message; }).join(' ');
    }
    if (res.status === 403) return 'Bu işlem için yetkiniz yok.';
    return 'İşlem tamamlanamadı, lütfen tekrar deneyin.';
  }

  /* Başarılı yanıtta state'i güncelle + listeyi yeniden render et */
  function applyState(res) {
    var d = res.d;
    if (!d || !d.ok) return false;
    state.addresses = d.addresses || [];
    state.defaultId = d.defaultAddressId || null;
    renderList();
    return true;
  }

  /* Sayfa seviyesi kısa bildirim — modal dışı işlemlerin (sil / varsayılan yap)
     geri bildirimi için. Önceden hata modal içi kutuya yazılıyordu → kapalı modalde kayboluyordu. */
  var toastTimer = null;
  function toast(msg, isError) {
    var el = document.getElementById('ero-acct-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'ero-acct-toast';
      el.className = 'ero-acct-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.toggle('is-error', !!isError);
    void el.offsetWidth;            // reflow → transition tetiklensin
    el.classList.add('is-visible');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3500);
  }

  function save() {
    if (state.busy) return;
    var f = readForm();
    var miss = validate(f);
    if (miss.length) { showError('Lütfen zorunlu alanları doldurun.'); return; }
    clearError();
    var payload = {
      action: state.editingId ? 'update' : 'create',
      address: {
        firstName: f.firstName.trim(), lastName: f.lastName.trim(), phone: f.phone.trim(),
        address1: f.address1.trim(), city: buildCity(f.ilce, f.il), zip: f.zip.trim(), countryCode: 'TR'
      },
      setAsDefault: !!f.setAsDefault
    };
    if (state.editingId) payload.addressId = state.editingId;
    setBusy(true);
    post(payload)
      .then(function (res) { if (applyState(res)) { closeModal(); } else { showError(resultErrorMsg(res)); } })
      .catch(function () { showError('Bağlantı hatası.'); })
      .then(function () { setBusy(false); });
  }
  function removeAddr(id) {
    if (state.busy) return;
    if (!window.confirm('Bu adresi silmek istediğinize emin misiniz?')) return;
    post({ action: 'delete', addressId: id })
      .then(function (res) {
        if (applyState(res)) { toast('Adres silindi.'); }
        else { toast(resultErrorMsg(res), true); }
      })
      .catch(function () { toast('Bağlantı hatası.', true); });
  }
  function makeDefault(id) {
    if (state.busy) return;
    post({ action: 'setDefault', addressId: id })
      .then(function (res) {
        if (applyState(res)) { toast('Varsayılan adres güncellendi.'); }
        else { toast(resultErrorMsg(res), true); }
      })
      .catch(function () { toast('Bağlantı hatası.', true); });
  }

  /* ── olaylar ── */
  MOUNT.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-act]'); if (!btn) return;
    var act = btn.getAttribute('data-act'), id = btn.getAttribute('data-id');
    if (act === 'add') openModal(null);
    else if (act === 'edit') openModal(byId(id));
    else if (act === 'delete') removeAddr(id);
    else if (act === 'setDefault') makeDefault(id);
  });
  MODAL.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-act]');
    if (btn && btn.getAttribute('data-act') === 'save') { save(); return; }
    if (btn && btn.getAttribute('data-act') === 'cancel') { closeModal(); return; }
    // Panel dışına tıklama (overlay + panel çevresindeki padding boşluğu) → kapat.
    // Eski kontrol sadece overlay öğesini yakalıyordu; 16px padding halkası ölü bölgeydi.
    if (!e.target.closest('.ero-addr-modal__panel')) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !MODAL.hasAttribute('hidden')) closeModal();
  });

  /* ── ilk yükleme ── */
  fetch(PROXY, { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
    .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
    .then(function (d) { if (!d || !d.ok) throw new Error('payload'); state.addresses = d.addresses || []; state.defaultId = d.defaultAddressId || null; renderList(); })
    .catch(function () { fallback(); });
})();
